import React from "react";
import { FocusAreaCard as PkgFocusAreaCard, type FocusAreaCardProps } from "@answersnow/pkg-clinical-program";

const FOCUS_AREA_LEARN_MORE_URL =
  "https://docs.google.com/document/d/1uhIiGZedChObbV-xmM5IMZVi3w7xxNarxDW1jfWLWpc/edit?tab=t.0#heading=h.s3s763uhgl96";

const FocusAreaCard: React.FC<FocusAreaCardProps> = (props) => (
  <PkgFocusAreaCard {...props} learnMoreUrl={FOCUS_AREA_LEARN_MORE_URL} />
);

export type { FocusAreaCardProps };
export default FocusAreaCard;
